export default "__VITE_ASSET__Drke2uy0__"